export default __webpack_public_path__ + "3de38fb9fc88ab26a1bb3e080a3a789f.svg";